<template>
  <div
    :id="widget.id"
    :gs-id="widget.id"
    :gs-w="widget.w"
    :gs-x="widget.x"
    :gs-y="widget.y"
    class="grid-stack-item"
    :class="{
      'grid-stack-overflow': shouldOverflow,
    }"
  >
    <div
      class="grid-stack-item-content"
      :class="{
        'grid-stack-overflow': shouldOverflow,
      }"
    >
      <component
        :is="widget.component"
        :editing="editing"
        :removing="removing"
        :widget="widget"
      />
    </div>
  </div>
</template>

<script>
import PriorityActions from './../actions/PriorityActions';
import CompletedActions from './../actions/CompletedActions';
import ActionProgress from './../actions/ActionProgress';

import AverageRanking from './../keywords/AverageKeywordRanking';
import KeywordRankings from './../keywords/KeywordRankings';

import TrafficStats from './../traffic/TrafficStats';
import TopTrafficSources from './../traffic/TopTrafficSources';
import TopCountries from './../traffic/TopCountries';
import TopCities from './../traffic/TopCities';
import TopReferrers from './../traffic/TopReferrers';
import TopDevices from './../traffic/TopDevices';
import WebsiteVisits from './../traffic/WebsiteVisits';

import ClicksAndImpressions from './../searchConsole/ClicksAndImpressions';

import DomainAuthority from './../backlinks/DomainAuthority';
import TopBacklinks from './../backlinks/TopBacklinks';
import NewBacklinks from './../backlinks/NewBacklinks';
import CompetitionKeywords from './../competition/CompetitionKeywords';
import CompetitionBacklinks from './../competition/CompetitionBacklinks';
import CorrectCitations from './../local/CorrectCitations';
import IncorrectCitations from './../local/IncorrectCitations';
import MissingCitations from './../local/MissingCitations';
import AllNewReviews from './../local/AllNewReviews';
import NewReviews3Plus from './../local/NewReviews3Plus';
import ScheduledPosts from './../local/ScheduledPosts';
import DirectionRequests from './../local/insights/DirectionRequests';
import MapViews from './../local/insights/MapViews';
import PhoneCalls from './../local/insights/PhoneCalls';
import SearchViews from './../local/insights/SearchViews';
import WebsiteClicks from './../local/insights/WebsiteClicks';
import LocalKeywordRankings from './../local/LocalKeywordRankings';
import AverageLocalRanking from './../local/AverageLocalRanking';
import CustomWidget from './../custom/CustomWidget';
import {mapActions} from 'vuex';

export default {
  components: {
    PriorityActions,
    CompletedActions,
    ActionProgress,
    AverageRanking,
    KeywordRankings,
    TrafficStats,
    TopTrafficSources,
    WebsiteVisits,
    TopCountries,
    TopCities,
    TopReferrers,
    TopDevices,
    ClicksAndImpressions,
    DomainAuthority,
    TopBacklinks,
    NewBacklinks,
    CompetitionKeywords,
    CompetitionBacklinks,
    CorrectCitations,
    IncorrectCitations,
    MissingCitations,
    AllNewReviews,
    NewReviews3Plus,
    ScheduledPosts,
    DirectionRequests,
    MapViews,
    PhoneCalls,
    SearchViews,
    WebsiteClicks,
    LocalKeywordRankings,
    AverageLocalRanking,
    CustomWidget
  },
  props: {
    widget: {
      type: Object,
      required: true
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  emits: ['editWidget'],
  data() {
    return {
      removing: false
    }
  },
  computed: {
    shouldOverflow: function () {
      return [
        'AverageRanking',
        'AverageLocalRanking',
        'WebsiteVisits',
        'ClicksAndImpressions',
        'DomainAuthority',
        'SearchViews',
        'PhoneCalls',
        'DirectionRequests',
      ].includes(this.widget.component);
    },
  },
  methods: {
    ...mapActions('dashboard', [
      'removeWidget'
    ]),
    edit() {
      this.$emit('editWidget', this.widget);
    },
    remove() {
      this.removing = true;
      this.$nextTick(() => {
        this.removeWidget(this.widget);
        this.removing = false;
      });
    }
  },

}
</script>

<style>
#dashboard-grid .grid-stack-item .grid-stack-item-content {
  background-color: unset;
  border: solid 1px rgba(0, 0, 0, 0);
  border-radius: 0.75rem;
}

.grid-stack-overflow {
  overflow: visible !important;
}

.grid-stack-overflow .white_box {
  overflow: visible !important;
}
</style>
